import validateAddress from './validateAddress';

const validateIntlAddress = (value: unknown): string | boolean => validateAddress(value, ['line1', 'city', 'postCode']);

export default validateIntlAddress;
